import { render, staticRenderFns } from "./EmergenceKeycaps.vue?vue&type=template&id=661c4dbd&scoped=true"
import script from "./EmergenceKeycaps.vue?vue&type=script&lang=ts"
export * from "./EmergenceKeycaps.vue?vue&type=script&lang=ts"
import style0 from "./EmergenceKeycaps.vue?vue&type=style&index=0&id=661c4dbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c4dbd",
  null
  
)

export default component.exports